import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import {getBinanceTransactionStatus, postBinanceDeposit} from "../../services/wallet/postBinanceDeposit.service";

const usePostBinanceDeposit = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: amount => postBinanceDeposit(amount),
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: ["userBinanceWallet"]});
      // Don't show message here, let the component handle it
    },
    onError: _error => {
      queryClient.invalidateQueries({queryKey: ["userBinanceWallet"]});
      // Don't show message here, let the component handle it
    },
  });
};

const useBinanceTransactionStatus = (orderId, enabled = false) => {
  return useQuery({
    queryKey: ["binanceTransactionStatus", orderId],
    queryFn: async () => {
      const response = await getBinanceTransactionStatus(orderId);
      return response;
    },
    enabled: enabled && !!orderId,
    refetchInterval: 3000, // Poll every 3 seconds
    refetchIntervalInBackground: false,
  });
};

export {usePostBinanceDeposit, useBinanceTransactionStatus};
